/*!
 * [Betbuilder Aggregator API] Module
 * Implementacia Betbuilder Aggregator API funkcionality
 */

betbuilderAgg = {

    texts: {}, // Bude naplnené z betbuilder-texts.js
    api: {},   // Bude naplnené z betbuilder-api.module.js
    panel: {}, // Bude naplnené z betbuilder-panel.module.js
    signalrModule: {}, // Bude naplnené z betbuilder-signalr.module.js

    // Flag pre jednorazovú inicializáciu
    _isInitialized: false,

    // Privátny state objekt
    _state: {
        eventID: null,              // ID aktualneho eventu
        selectedOdds: [],           // Pole vybranych oddov [{oddID, name, value, ...}]
        availableOdds: [],          // Vsetky dostupne oddy pre BB
        conflictedOdds: [],         // Oddy ktore su v konflikte s vybranymi
        notConflictedOdds: [],      // Oddy ktore nie su v konflikte s vybranymi
        totalOddsValue: " - ",      // Celkovy kurz vybranych oddov
        maxOdds: 10,                // Maximalny pocet oddov v BB
        isLoading: false,           // Flag pre loading state
        isCalculating: false,       // Flag pre vypocet konfliktov (calculate-filter-odds API)
        errorMessage: null,         // Aktualna chybova hlaska
        debugErrorMessage: null,    // Debug chybova hlaska
        isTabActive: false,         // Ci je aktivna karta s BB
        isSuspended: false,         // Ci je MultiOdd pozastaveny (SignalR Status)
        signalrGroupName: null,     // Nazov SignalR skupiny pre MultiOdd aktualizacie
        lastCreatedMultiOdd: null,  // Posledny vytvoreny MultiOdd {oddID, oddRate, timestamp}
        showNoOpportunitiesMessage: false,  // Zobrazit info ze nie su prilezitosti (0-1 oddov)
        debug: false                 // Zapnutie zobrazovania hlášky debug logov do modal pre BetBuilder BE odpovede
    },

    // Registrácia listenerov pre zmeny
    _listeners: {
        selectedOdds: ['renderAvailableOdds', 'renderPanel', 'updateSelectionModalContent'],
        conflictedOdds: ['renderAvailableOdds'],
        notConflictedOdds: ['renderAvailableOdds'],
        availableOdds: ['renderAvailableOdds'],
        totalOddsValue: ['renderPanel', 'updateSelectionModalContent'],
        isSuspended: ['renderPanel', 'updateSelectionModalContent'],
        showNoOpportunitiesMessage: ['renderNoOpportunitiesMessage'],
        isTabActive: ['renderNoOpportunitiesMessage', 'renderAvailableOdds'],
        isLoading: ['renderLoadingState'],
        isCalculating: ['renderLoadingState'],
        errorMessage: ['renderError']
    },

    // Batch update mechanizmus pre optimalizáciu
    _pendingUpdates: new Set(),
    _updateScheduled: false,

    // Vytvorenie Proxy pre sledovanie zmien
    state: null, // Bude inicializovane v _initProxy

    // Inicializacia Proxy pre state
    _initProxy: function() {
        var self = this;
        this.state = new Proxy(this._state, {
            set: function(target, property, value) {
                var oldValue = target[property];
                
                // Kontrola či sa hodnota skutočne zmenila
                if (oldValue === value) {
                    return true;
                }

                // Pre polia - check či sú obe prázdne
                if (Array.isArray(oldValue) && Array.isArray(value)) {
                    if (oldValue.length === 0 && value.length === 0) {
                        return true; // Obe prázdne = žiadna zmena
                    }
                }

                // Nastavenie novej hodnoty
                target[property] = value;

                // Zaradenie do batch update
                self._scheduleUpdate(property);
                
                return true;
            },

            get: function(target, property) {
                return target[property];
            }
        });
    },

    // Plánovanie batch update
    _scheduleUpdate: function(property) {
        this._pendingUpdates.add(property);

        if (!this._updateScheduled) {
            this._updateScheduled = true;
            var self = this;
            
            // Použitie requestAnimationFrame pre optimálne renderovanie
            requestAnimationFrame(function() {
                self._processPendingUpdates();
            });
        }
    },

    // Spracovanie naplánovaných aktualizácií
    _processPendingUpdates: function() {
        var updates = Array.from(this._pendingUpdates);
        this._pendingUpdates.clear();
        this._updateScheduled = false;

        // Kolekcia unikátnych render funkcií ktoré treba zavolať
        var renderFunctionsToCall = new Set();
        var self = this;

        updates.forEach(function(property) {
            var listeners = self._listeners[property];
            if (listeners) {
                listeners.forEach(function(fn) {
                    renderFunctionsToCall.add(fn);
                });
            }
        });

        // Zavolanie render funkcií v správnom poradí
        var renderOrder = [
            'renderLoadingState',
            'renderError',
            'renderNoOpportunitiesMessage',
            'renderAvailableOdds',
            'renderPanel',
            'updateSelectionModalContent'
        ];

        renderOrder.forEach(function(fnName) {
            if (renderFunctionsToCall.has(fnName)) {
                // renderPanel a updateSelectionModalContent sú v betbuilderAgg.panel
                if (fnName === 'renderPanel' || fnName === 'updateSelectionModalContent') {
                    if (typeof betbuilderAgg.panel[fnName] === 'function') {
                        betbuilderAgg.panel[fnName]();
                    }
                } else if (typeof self[fnName] === 'function') {
                    self[fnName]();
                }
            }
        });
    },

    // Jednorazová inicializácia - texty, proxy (volá sa len raz)
    _initOnce: function() {
        if (betbuilderAgg._isInitialized) {
            return;
        }

        // Inicializácia Proxy
        if (!betbuilderAgg.state) {
            betbuilderAgg._initProxy();
        }

        betbuilderAgg._isInitialized = true;
    },

    // Inicializácia BetBuilderu pre konkrétny event
    init: function(eventID, activateTab) {

        // ak mam event id tak sa pokusim nacitat dostupne oddy
        if (eventID) {
            // Jednorazová inicializácia
            betbuilderAgg._initOnce();

            // Inicializácia textov - zavolá sa až keď sú načítané preklady
            betbuilderAgg.initTexts();
            
            var isRefresh = (betbuilderAgg.state.eventID === eventID);
            
            if (betbuilderAgg.state.eventID !== eventID) {
                // Ak sa zmenil event, resetujem stav
                betbuilderAgg.destroy();
            }
            betbuilderAgg.state.eventID = eventID;
            
            // Nastavenie isTabActive na základe parametra activateTab
            // Toto je JEDINÉ miesto, kde sa nastavuje isTabActive pri inicializácii
            if (activateTab) {
                betbuilderAgg.state.isTabActive = true;
            }
            
            // Pri refresh načítavame oddy vždy (aby sa aktualizovali a spustil render)
            // Pri prvom načítaní načítavame len ak nemáme oddy
            if (isRefresh || betbuilderAgg.state.availableOdds.length === 0) {
                betbuilderAgg.state.showNoOpportunitiesMessage = false;
                betbuilderAgg.loadAvailableOdds(eventID);
            }
            // renderAvailableOdds sa zavola automaticky cez Proxy pri zmene availableOdds
        } else {
            // Event ID nie je dostupne, nezobrazujem betbuilder
            return false;
        }
    },

    // Deaktivácia BetBuilder tabu (zavolá sa pri prepnutí na iný tab)
    deactivate: function() {
        if (betbuilderAgg.state.isTabActive) {
            // Panel sa schová automaticky cez Proxy listener
            betbuilderAgg.state.isTabActive = false;

            betbuilderAgg.state.selectedOdds = [];
            betbuilderAgg.state.conflictedOdds = [];
            betbuilderAgg.state.notConflictedOdds = [];
            betbuilderAgg.state.totalOddsValue = " - ";

            // Odstránenie BetBuilder selected class zo všetkých oddov pri prepnutí na iný tab
            document.querySelectorAll("#event .chances .betbuilder-agg--selected").forEach(function(element) {
                element.classList.remove("betbuilder-agg--selected");
            });
            
            // Zavrieť modal ak je otvorený
            if (dialog.isOpen("betbuilder-agg__selected-odds-dialog")) {
                dialog.close("betbuilder-agg__selected-odds-dialog");
            }
        }
    },

    destroy: function() {

        // Kontrola či bol betbuilder vôbec inicializovaný
        if (!this.state) {
            return;
        }

        // Odstranenie BetBuilderu - reset stavu a prerendrovanie oddov do povodneho stavu
        
        // Zavrieť modal ak je otvorený
        if (dialog.isOpen("betbuilder-agg__selected-odds-dialog")) {
            dialog.close("betbuilder-agg__selected-odds-dialog");
        }
        
        // Unsubscribe zo SignalR skupiny
        if (betbuilderAgg.signalrModule) {
            betbuilderAgg.signalrModule.reset();
        }
        
        // Odstránenie BetBuilder selected class zo všetkých oddov
        document.querySelectorAll("#event .chances .betbuilder-agg--selected").forEach(function(element) {
            element.classList.remove("betbuilder-agg--selected");
        });
        
        // Reset každej vlastnosti osobitne aby sa spustil Proxy
        betbuilderAgg.state.eventID = null;
        betbuilderAgg.state.selectedOdds = [];
        betbuilderAgg.state.availableOdds = [];
        betbuilderAgg.state.conflictedOdds = [];
        betbuilderAgg.state.notConflictedOdds = [];
        betbuilderAgg.state.totalOddsValue = " - ";
        betbuilderAgg.state.maxOdds = 10;
        betbuilderAgg.state.isLoading = false;
        betbuilderAgg.state.isCalculating = false;
        betbuilderAgg.state.errorMessage = null;
        betbuilderAgg.state.debugErrorMessage = null;
        betbuilderAgg.state.isTabActive = false;
        betbuilderAgg.state.isSuspended = false;
        betbuilderAgg.state.signalrGroupName = null;
        betbuilderAgg.state.lastCreatedMultiOdd = null;
        betbuilderAgg.state.showNoOpportunitiesMessage = false;
    },

    loadAvailableOdds: function(eventID) {
        // Ak už beží načítavanie, nevolať znova (prevencia duplicitných API callov)
        if (betbuilderAgg.state.isLoading) {
            return;
        }
        
        betbuilderAgg.state.isLoading = true;
        
        // Uloženie aktuálne vybraných oddov pre prípad refresh
        var previouslySelectedOdds = betbuilderAgg.state.selectedOdds.slice();
        
        betbuilderAgg.api.loadAvailableOdds(eventID, {
            onSuccess: function(response) {
                
                // Validacia response
                if (!response) {
                    betbuilderAgg.state.isLoading = false;
                    return;
                }
                
                // Ak OddsIDs neexistuje (undefined/null) ale response je validná,
                // je to chyba/nevalidná response - zachovať predchádzajúci stav
                if (response.OddsIDs === undefined || response.OddsIDs === null) {
                    betbuilderAgg.state.isLoading = false;
                    return;
                }
                
                if (!Array.isArray(response.OddsIDs)) {
                    betbuilderAgg.state.errorMessage = betbuilderAgg.texts.BetBuilderAggLoadError;
                    betbuilderAgg.state.isLoading = false;
                    return;
                }
                
                // Validne data - nastavenie stavu
                // Aj prázdny array [] je legitímny stav (žiadne príležitosti)
                betbuilderAgg.state.availableOdds = response.OddsIDs;
                
                // Kontrola počtu dostupných oddov
                if (betbuilderAgg.state.availableOdds.length < 2) {
                    // Zobrazit info spravu ze nie su dostupne prilezitosti
                    betbuilderAgg.state.showNoOpportunitiesMessage = true;
                    // Vyčistiť výber a konflikty ak nie sú dostupné žiadne príležitosti
                    if (betbuilderAgg.state.availableOdds.length === 0) {
                        betbuilderAgg.state.selectedOdds = [];
                        betbuilderAgg.state.conflictedOdds = [];
                    }
                } else {
                    // Dostatok prilezitosti - skryt info spravu
                    betbuilderAgg.state.showNoOpportunitiesMessage = false;
                    
                    // Pri refresh - zachovať vybrané oddy ak sú stále dostupné
                    if (previouslySelectedOdds.length > 0) {
                        // Normalizacia na stringy
                        var availableOddsStr = betbuilderAgg.state.availableOdds.map(String);
                        
                        // Filtrovať len tie oddy ktoré sú stále dostupné
                        var validSelectedOdds = previouslySelectedOdds.filter(function(oddID) {
                            return availableOddsStr.includes(String(oddID));
                        });
                        
                        // Ak máme aspoň 1 platný odd, zachovať výber
                        if (validSelectedOdds.length > 0) {
                            betbuilderAgg.state.selectedOdds = validSelectedOdds;
                            // Nastaviť calculating flag pre ochranu
                            betbuilderAgg.state.isCalculating = true;
                            // Prepočítať konflikty pre zachované oddy
                            betbuilderAgg.calculateFilterOdds();
                        } else {
                            // Ak žiadne platné oddy, vymazať výber
                            betbuilderAgg.state.selectedOdds = [];
                            betbuilderAgg.state.conflictedOdds = [];
                            betbuilderAgg.state.notConflictedOdds = [];
                        }
                    }
                }
                
                betbuilderAgg.state.isLoading = false;
            },
            onError: function(error) {
                betbuilderAgg.state.isLoading = false;
                betbuilderAgg.state.errorMessage = betbuilderAgg.texts.BetBuilderAggLoadError;
            }
        });
    },

    renderAvailableOdds: function() {
        try {
            // Renderovať oddy len ak je BetBuilder tab aktívny
            if (!betbuilderAgg.state.isTabActive) {
                return;
            }
            
            // Ak sa zobrazuje info správa o nedostatku príležitostí, skryť všetky oddy
            if (betbuilderAgg.state.showNoOpportunitiesMessage) {
                document.querySelectorAll("#event .chances [odd-betbuilder-agg]").forEach(function(element) {
                    element.setAttribute("odd-betbuilder-agg", "false");
                    element.classList.remove("betbuilder-agg--selected");
                });
                return;
            }
            
            // Normalizacia vsetkych poli na stringy pre spravne porovnavanie
            var availableOddsStr = betbuilderAgg.state.availableOdds.map(String);
            var selectedOddsStr = betbuilderAgg.state.selectedOdds.map(String);
            var conflictedOddsStr = betbuilderAgg.state.conflictedOdds.map(String);

            // ak nie su dostupne ziadne oddy rendrujem spravu o nedostatku prilezitosti a skryvam oddy
            if (availableOddsStr.length === 0) {
                betbuilderAgg.state.showNoOpportunitiesMessage = true;
                //return;
            } else {
                betbuilderAgg.state.showNoOpportunitiesMessage = false;
            }

            
            document.querySelectorAll("#event .chances [odd-betbuilder-agg]").forEach(function(element) {
                var oddID = element.id.toString();
                
                if (!availableOddsStr.includes(oddID)) {
                    // Odd nie je dostupny pre BetBuilder, skryjem ho iba ak sa atribut nezmenil
                    if (element.getAttribute("odd-betbuilder-agg") !== "false") {
                        element.setAttribute("odd-betbuilder-agg", "false");
                    }
                    element.classList.remove("betbuilder-agg--selected"); // Odstranit zvyraznenie
                } else if (conflictedOddsStr.includes(oddID)) {
                    // Odd je v konflikte s vybranymi oddmi, iba ak sa atribut nezmenil
                    if (element.getAttribute("odd-betbuilder-agg") !== "conflict") {
                        element.setAttribute("odd-betbuilder-agg", "conflict");
                    }
                    element.classList.remove("betbuilder-agg--selected"); // Odstranit zvyraznenie selected stavu
                } else if (selectedOddsStr.includes(oddID)) {
                    // Odd je vybrany, zobrazim ho ako aktivny
                    if (element.getAttribute("odd-betbuilder-agg") !== "true") {
                        element.setAttribute("odd-betbuilder-agg", "true");
                    }
                    element.classList.add("betbuilder-agg--selected"); // Zvyraznenie BetBuilder oddov
                } else {
                    // Odd je dostupny pre BetBuilder, zobrazim ho
                    if (element.getAttribute("odd-betbuilder-agg") !== "true") {
                        element.setAttribute("odd-betbuilder-agg", "true");
                    }
                    element.classList.remove("betbuilder-agg--selected"); // Odstranit zvyraznenie
                }
            });

            // check a nastavenie scroll butonov
            shared.scrollModule.scrollButtons("event")
            
        } catch (error) {
            console.error('[BetBuilder] Error in renderAvailableOdds:', error);
        }
    },

    addOddToBetBuilder: function(oddID) {
        // Pridanie oddu do betbuilderu - zavolam API pre pridanie oddu do aktualneho betbuilderu
        if (betbuilderAgg.state.isTabActive) {
            // Blokovať pridávanie oddov počas výpočtu konfliktov
            if (betbuilderAgg.state.isCalculating) {
                return false;
            }

            var selectedIndex = betbuilderAgg.state.selectedOdds.indexOf(oddID);
            
            // Kontrola maximalneho poctu oddov PRED pridanim (ochrana proti race condition)
            if (selectedIndex === -1 && betbuilderAgg.state.selectedOdds.length >= betbuilderAgg.state.maxOdds) {
                betbuilderAgg.state.errorMessage = betbuilderAgg.texts.BetBuilderAggMaxOdds;
                return false;
            }

            // Konfliktny odd sa nesmie pridat ani prepocitat
            var conflictedIndex = betbuilderAgg.state.conflictedOdds.indexOf(oddID);

            if (conflictedIndex !== -1) {
                betbuilderAgg.state.errorMessage = [ betbuilderAgg.texts.BetBuilderAggConflictMessageHeader, betbuilderAgg.texts.BetBuilderAggConflictMessageText ];
                return false;
            }
            
            if (selectedIndex === -1) {
                // Pridanie - vytvorit nové pole spustí Proxy
                betbuilderAgg.state.selectedOdds = betbuilderAgg.state.selectedOdds.concat([oddID]);
            } else {
                // Odstránenie - vytvorit nové pole spustí Proxy
                betbuilderAgg.state.selectedOdds = betbuilderAgg.state.selectedOdds.filter(function(id) {
                    return id !== oddID;
                });
            }
            
            // Nastaviť calculating flag HNEĎ pre ochranu proti race condition
            betbuilderAgg.state.isCalculating = true;
            
            // Výpočet konfliktov
            if (betbuilderAgg.state.selectedOdds.length > 0) {
                betbuilderAgg.calculateFilterOdds();
            } else {
                // Ak je prazdny stav oddu, vycistim konfliktne oddy
                betbuilderAgg.state.conflictedOdds = [];
                betbuilderAgg.state.notConflictedOdds = [];
                betbuilderAgg.state.isCalculating = false;
            }
            
            // Render sa zavola automaticky cez Proxy
            // Zamedzit pridanie oddu na ticket, ak je aktivna karta s betbuilderom
            return false;
        }
    },

    // Volanie calculate-filter-odds API pre ziskanie konfliktnych oddov
    calculateFilterOdds: function() {
        if (betbuilderAgg.state.selectedOdds.length === 0) {
            // Ak nie su ziadne oddy, vymaz konfliktne oddy
            betbuilderAgg.state.conflictedOdds = [];
            betbuilderAgg.state.notConflictedOdds = [];
            // Render sa zavola automaticky cez Proxy
            return true;
        }

        // Nastaviť calculating flag pre blokovanie ďalších kliknutí
        betbuilderAgg.state.isCalculating = true;

        betbuilderAgg.api.calculateFilterOdds(betbuilderAgg.state.selectedOdds, {
            onSuccess: function(response) {
                
                // Validacia response
                if (!response) {
                    betbuilderAgg.state.isCalculating = false;
                    return;
                }
                
                // Kontrola chybovej odpovede z API
                if (response.ErrorCode || response.ErrorKey) {
                    
                    var errorMessage = "Unknown error";
                    
                    // Pokus o parsovanie ErrorMessage ak obsahuje JSON
                    if (response.ErrorMessage) {
                        try {
                            var errorData = JSON.parse(response.ErrorMessage);
                            if (errorData.message) {
                                errorMessage = errorData.message;
                            }
                        } catch (e) {
                            // Ak parsovanie zlyhá, použijeme priamu hodnotu
                            errorMessage = response.ErrorMessage;
                        }
                    }

                    betbuilderAgg.state.debugErrorMessage = "API ErrorCode: " + response.ErrorCode + ", <br> ErrorKey: " + response.ErrorKey + ", <br> Message: " + errorMessage;
                    
                    // Zatvoriť modal ak je otvorený
                    if (dialog.isOpen("betbuilder-agg__selected-odds-dialog")) {
                        dialog.close("betbuilder-agg__selected-odds-dialog");
                    }
                    
                    // Vypnúť calculating flag
                    betbuilderAgg.state.isCalculating = false;
                    
                    // Odstrániť posledný pridaný odd (ktorý spôsobil konflikt)
                    if (betbuilderAgg.state.selectedOdds.length > 0) {
                        var lastOddID = betbuilderAgg.state.selectedOdds[betbuilderAgg.state.selectedOdds.length - 1];
                        
                        betbuilderAgg.state.selectedOdds = betbuilderAgg.state.selectedOdds.slice(0, -1);
                        
                        // Pre zostávajúce oddy zavolať znova calculateFilterOdds()
                        if (betbuilderAgg.state.selectedOdds.length > 0) {
                            // Rekurzívne volanie pre aktualizované oddy
                            setTimeout(function() {
                                betbuilderAgg.calculateFilterOdds();
                            }, 0);
                        } else {
                            betbuilderAgg.state.conflictedOdds = [];
                            betbuilderAgg.state.notConflictedOdds = [];
                        }
                    }
                    
                    betbuilderAgg.state.errorMessage = [ betbuilderAgg.texts.BetBuilderAggConflictMessageHeader, betbuilderAgg.texts.BetBuilderAggConflictMessageText ];
                    return;
                }
                
                // Aktualizuj celkovy kurz z response
                if (response.OddsRate !== undefined && response.OddsRate !== null) {
                    var oddsRate = parseFloat(response.OddsRate);
                    if (!isNaN(oddsRate) && oddsRate > 0) {
                        betbuilderAgg.state.totalOddsValue = oddsRate;
                    } else {
                        console.warn("calculate-filter-odds: Invalid OddsRate value", response.OddsRate);
                    }
                }

                // Parse konfliktnych oddov z Events array
                var newConflictedOdds = [];
                var newNotConflictedOdds = [];
                                
                if (Array.isArray(response.Events) && response.Events.length > 0) {
                    response.Events.forEach(function(event, eventIndex) {

                        if (!event) return;
                                                
                        if (Array.isArray(event.OddsRestricted) && event.OddsRestricted.length > 0) {
                            event.OddsRestricted.forEach(function(odd) {
                                if (!odd || odd.OddsID === undefined || odd.OddsID === null) {
                                    return;
                                }
                                
                                if (odd.IsConflict) {
                                    newConflictedOdds.push(odd.OddsID);
                                } else {
                                    newNotConflictedOdds.push(odd.OddsID);
                                }
                            });
                        }
                    });
                }
                
                // Nastavenie nových hodnôt spustí Proxy a automaticky render
                betbuilderAgg.state.conflictedOdds = newConflictedOdds;
                betbuilderAgg.state.notConflictedOdds = newNotConflictedOdds;
                
                // Subscribe na SignalR pre real-time aktualizácie MultiOdd kurzu
                if (betbuilderAgg.signalrModule) {
                    betbuilderAgg.signalrModule.subscribe();
                }
                
                // Vypnúť calculating flag
                betbuilderAgg.state.isCalculating = false;
            },
            onError: function(error) {
                // Zatvoriť modal ak je otvorený
                if (dialog.isOpen("betbuilder-agg__selected-odds-dialog")) {
                    dialog.close("betbuilder-agg__selected-odds-dialog");
                }
                
                // Vypnúť calculating flag aj pri chybe
                betbuilderAgg.state.isCalculating = false;
                
                // Zobrazenie error message
                betbuilderAgg.state.errorMessage = betbuilderAgg.texts.BetBuilderAggLoadError;
            }
        });

        return true;
    },

    // Rendering BetBuilder panela
    renderPanel: function() {
        betbuilderAgg.panel.renderPanel();
    },

    // Render loading state
    renderLoadingState: function() {
        if (betbuilderAgg.state.isLoading || betbuilderAgg.state.isCalculating) {
            if (typeof modal !== 'undefined' && modal.showLoading) {
                modal.showLoading();
            }
        } else {
            if (typeof modal !== 'undefined' && modal.hideLoading) {
                modal.hideLoading();
            }
        }
    },

    // Render error message
    renderError: function() {
        if (betbuilderAgg.state.isTabActive && betbuilderAgg.state.errorMessage) {
            var header, text = null;
            // ak ma error viac textov array, napr conflict
            if (Array.isArray(betbuilderAgg.state.errorMessage)) {
                var header = betbuilderAgg.state.errorMessage[0];
                var text = betbuilderAgg.state.errorMessage[1];
                // Zobrazenie error message
            } else {
                var header = betbuilderAgg.state.errorMessage;
            }
            header = betbuilderAgg.state.debug && betbuilderAgg.state.debugErrorMessage != null ? header + `<small style='background-color:red;color:white;'><br>DEBUG:<br> ${betbuilderAgg.state.debugErrorMessage}</small>` : header;
            // Zobrazenie error message
            modal.showInfoModal(3, sets.infoModalTime, true, header, text, false, false, {
                buttonCloseText: betbuilderAgg.texts.BetBuilderAggConflictButton,
                buttonCloseAction: "modal.hideInfoModal();"
            });
            // Vymazanie chybovej hlásky po zobrazení
            betbuilderAgg.state.errorMessage = null;
            betbuilderAgg.state.debugErrorMessage = null;

        }
    },

    // Render info message o nedostatku príležitostí
    renderNoOpportunitiesMessage: function() {
        try {
            var container = document.querySelector("#event .chances");
            if (!container) {
                return;
            }
            
            // Odstránenie existujúcej info správy
            var existingMessage = document.getElementById("betbuilder-agg-no-opportunities");
            if (existingMessage) {
                existingMessage.remove();
            }
            
            // Zobraziť správu len ak je tab aktívny a zároveň nemáme dostatok príležitostí
            if (betbuilderAgg.state.isTabActive && betbuilderAgg.state.showNoOpportunitiesMessage) {
                var infoHtml = `
                    <div id="betbuilder-agg-no-opportunities" class="betbuilder-agg__no-opportunities">
                        ${betbuilderAgg.texts.BetBuilderAggNoOpportunitiesMessage}
                    </div>
                `;
                
                container.insertAdjacentHTML('afterbegin', infoHtml);
            }
        } catch (error) {
            console.error('[BetBuilder] Error in renderNoOpportunitiesMessage:', error);
        }
    },

    // Odstránenie oddu z BetBuilder výberu
    removeOddFromBetBuilder: function(oddID) {
        try {
            // Blokovať odstránenie počas výpočtu konfliktov
            if (betbuilderAgg.state.isCalculating) {
                return false;
            }
            
            // Nájdenie a odstránenie oddu zo selectedOdds
            var selectedIndex = betbuilderAgg.state.selectedOdds.indexOf(oddID);
            if (selectedIndex !== -1) {
                // Odstránenie - vytvorenie nového poľa spustí Proxy
                betbuilderAgg.state.selectedOdds = betbuilderAgg.state.selectedOdds.filter(function(id) {
                    return id !== oddID;
                });
                
                // Nastaviť calculating flag HNEĎ pre ochranu proti race condition
                betbuilderAgg.state.isCalculating = true;
                
                // Aktualizovať konfliktové oddy
                if (betbuilderAgg.state.selectedOdds.length > 0) {
                    // Modal sa aktualizuje automaticky cez Proxy listener
                    betbuilderAgg.calculateFilterOdds();
                } else {
                    // Ak už nie sú žiadne oddy, vyčistím konfliktne oddy
                    betbuilderAgg.state.conflictedOdds = [];
                    betbuilderAgg.state.notConflictedOdds = [];
                    betbuilderAgg.state.isCalculating = false;
                    
                    // Zatvoriť modal ak je otvorený
                    dialog.close("betbuilder-agg__selected-odds-dialog");
                }
                
                // Render sa zavola automaticky cez Proxy
            } else {
                console.warn("Odd " + oddID + " nie je v BetBuilderi");
            }
        } catch (error) {
            console.error('[BetBuilder] Error in removeOddFromBetBuilder:', error);
        }
    },

    /**
     * Odstráni suspended oddy z BetBuilder výberu
     * Volané z SignalR pri zmene stavu oddov alebo skupin ECT na suspended
     * @param {string|number|Array} oddIDs - Jedno oddID alebo pole oddIDs
     */
    handleSuspendedOdds: function(oddIDs) {
        try {
            // Ak nie je inicializovaný alebo nie je aktívny tab, nič nerobíme
            if (!betbuilderAgg.state || !betbuilderAgg.state.isTabActive) {
                return;
            }

            // Normalizácia vstupu na pole
            var oddsToRemove = Array.isArray(oddIDs) ? oddIDs : [oddIDs];
            
            // Konverzia na numbers pre porovnanie (selectedOdds sú numbers)
            var oddsToRemoveNum = oddsToRemove.map(Number);
            
            // Filtrovanie - odstránime suspended oddy zo selectedOdds
            var remainingOdds = betbuilderAgg.state.selectedOdds.filter(function(oddID) {
                return !oddsToRemoveNum.includes(oddID);
            });
            
            // Ak sa zmenil počet vybraných oddov
            if (remainingOdds.length !== betbuilderAgg.state.selectedOdds.length) {
                betbuilderAgg.state.selectedOdds = remainingOdds;
                
                // Nastaviť calculating flag pre ochranu
                betbuilderAgg.state.isCalculating = true;
                
                // Prepočítať konflikty pre zostávajúce oddy
                if (remainingOdds.length > 0) {
                    betbuilderAgg.calculateFilterOdds();
                } else {
                    betbuilderAgg.state.conflictedOdds = [];
                    betbuilderAgg.state.notConflictedOdds = [];
                    betbuilderAgg.state.isCalculating = false;
                }
            }
        } catch (error) {
            console.error('[BetBuilder] Error in handleSuspendedOdds:', error);
        }
    },

    // Pridanie BetBuilder kombinácie na tiket
    addToTicket: function() {
        // Validácia - MultiOdd nesmie byť pozastavený
        if (betbuilderAgg.state.isSuspended) {
            betbuilderAgg.state.errorMessage = betbuilderAgg.texts.BetBuilderAggSuspendedMessage;
            return;
        }
        
        // Validácia - musia byť vybrané aspoň 2 oddy pre BetBuilder
        if (betbuilderAgg.state.selectedOdds.length < 2) {
            betbuilderAgg.state.errorMessage = betbuilderAgg.texts.BetBuilderAggMinOdds;
            return;
        }

        // Nastavení loading stavu
        betbuilderAgg.state.isLoading = true;

        // Volanie multi-odd API pre vytvorenie MultiOdd
        betbuilderAgg.api.createMultiOdd(betbuilderAgg.state.selectedOdds, {
            onSuccess: function(response) {                
                // Kontrola chybovej odpovede z API
                if (response && (response.ErrorCode || response.ErrorKey)) {
                    
                    var errorMessage = betbuilderAgg.texts.BetBuilderAggAddError
                    
                    // Pokus o parsovanie ErrorMessage ak obsahuje JSON
                    if (response.ErrorMessage) {
                        try {
                            var errorData = JSON.parse(response.ErrorMessage);
                            if (errorData.message) {
                                errorMessage = errorData.message;
                            }
                        } catch (e) {
                            // Ak parsovanie zlyhá, použijeme priamu hodnotu
                            errorMessage = response.ErrorMessage;
                        }
                    }
                    
                    betbuilderAgg.state.errorMessage = errorMessage;
                    betbuilderAgg.state.isLoading = false;
                    return;
                }
                
                // Validácia response
                if (!response || !response.OddsID) {
                    betbuilderAgg.state.errorMessage = betbuilderAgg.texts.BetBuilderAggAddError;
                    betbuilderAgg.state.isLoading = false;
                    return;
                }

                var multiOddID = response.OddsID;
                var multiOddRate = response.OddsRate || betbuilderAgg.state.totalOddsValue;

                // Uloženie posledného vytvoreného MultiOdd pre prípad potreby
                betbuilderAgg.state.lastCreatedMultiOdd = {
                    oddID: multiOddID,
                    oddRate: multiOddRate,
                    timestamp: Date.now()
                };

                // Pridanie MultiOdd na tiket pomocou existujúcej funkcie
                // Server načíta kurz podľa OddsID, SignalR zabezpečí real-time aktualizáciu
                ticket.ticketOddModule.ctAddOdd(multiOddID, "betbuilder");

                // Prepnutie na default tab (Populárne/Aktívne)
                betbuilderAgg._switchToDefaultTab();
                
                // Vyčistení stavu (zatvára aj modal)
                betbuilderAgg.destroy();
                betbuilderAgg.state.isLoading = false;
            },
            onError: function(error) {
                console.error("BetBuilder: Error creating multi-odd", error);
                betbuilderAgg.state.errorMessage = betbuilderAgg.texts.BetBuilderAggAddError;
                betbuilderAgg.state.isLoading = false;
            }
        });
    },

    /**
     * Formatuje ChanceType pre BetBuilder Aggregator
     * @param {string} chanceType - ChanceType string vo formate "odd | tip && odd | tip"
     * @returns {string} - Formatovany HTML string
     */

    formatAggregatorChanceType: function(chanceType) {
        if (!chanceType) return '';
        
        // Rozdelenie podla " && " na jednotlive prilezitosti
        var opportunities = chanceType.split(' && ');
        
        // Mapovanie kazdeho opportunity na HTML
        var formattedHtml = opportunities.map(function(opportunity) {
            // Rozdelenie nazvu oddu a tipu podla " | "
            var parts = opportunity.split(' | ');
            if (parts.length === 2) {
                // Format: "nazov oddu: tip"
                return `
                    <div class="betbuilder-agg__ticket-odd-list-item">
                        <span class="betbuilder-agg__ticket-odd-list-item__name">${parts[0]}</span>
                        <span class="betbuilder-agg__ticket-odd-list-item__tip">
                            <span class="betbuilder-agg__ticket-odd-list-item__label">TIP:</span> ${parts[1]}
                        </span>
                    </div>`;
            } else {
                // Fallback ak nie je " | " oddelovac
                return '<div>' + opportunity + '</div>';
            }
        }).join('');
        
        return formattedHtml;
    },

    // Prepnutie na default tab (Populárne alebo Aktívne)
    _switchToDefaultTab: function() {
        try {
            // Zistiť či je event LIVE alebo prematch
            var defaultTab = (offer.eventLive === "Y") 
                ? offer.groupLive 
                : offer.groupPrematch;
            
            eventDetail.eventDetailFilter(defaultTab, true);
        } catch (error) {
            console.error('[BetBuilder] Error switching tab:', error);
        }
    },

    /**
     * Vracia hodnotu odd-betbuilder-agg atribútu pre daný odd
     * Používa sa pri renderovaní direktívy event detailu
     * @param {string|number} oddID - ID oddu
     * @returns {string} - "true", "conflict", "false" alebo "null"
     */
    checkOddAvailability: function(oddID) {
        // Ak BetBuilder nie je povolený alebo inicializovaný, vráť null
        if (!profile.BetBuilderAgg || !betbuilderAgg.state) {
            return "null";
        }
        
        // Odd je dostuoný pre betbuilder agg
        if (betbuilderAgg.state.availableOdds.includes(oddID)) {
            return "true";
        }
        
        // Odd je v konflikte
        if (betbuilderAgg.state.conflictedOdds.includes(oddID)) {
            return "conflict";
        }
        
        // Odd nie je dostupný pre betbuilder agg 
        return "false";
    }

};